<div style="text-align:center;font-weight:bold;margin-bottom:0.5rem">{{finishedProduct?.calcName}}</div>
<table class="second-unit">
  <tr><th>2nd unit</th><th>Unit</th><th>Price in {{price.currency}}</th></tr>
  <tr>
    <td>
      <input type="radio" [(ngModel)]="secondUnit" [name]="name" [value]="1" (ngModelChange)="onUnitChange(1, pricePc)" /> 
    </td>
    <td>pc</td>
    <!-- <td>{{dm.metrics.pc | number:'1.4-4'}}</td> -->
    <td>{{pricePc | number:'1.4-4'}}</td>
  </tr>
  <tr>
    <td>
      <input type="radio" [(ngModel)]="secondUnit" [name]="name" [value]="4" (ngModelChange)="onUnitChange(4, priceM2)" /> 
    </td>
    <td>m²</td>
    <!-- <td>{{dm.metrics.m2 | number:'1.4-4'}}</td> -->
    <td>{{priceM2 | number:'1.4-4'}}</td>
  </tr>
  <tr>
    <td>
      <input type="radio" [(ngModel)]="secondUnit" [name]="name" [value]="2" (ngModelChange)="onUnitChange(2, priceM)" /> 
    </td>
    <td>lm</td>
    <!-- <td>{{dm.metrics.m | number:'1.4-4'}}</td> -->
    <td>{{priceM | number:'1.4-4'}}</td>
  </tr>
  <tr>
    <td>
      <input type="radio" [(ngModel)]="secondUnit" [name]="name" [value]="3" (ngModelChange)="onUnitChange(3, priceM100)" /> 
    </td>
    <td>100lm</td>
    <!-- <td>{{dm.metrics.m100 | number:'1.4-4'}}</td> -->
    <td>{{priceM100 | number:'1.4-4'}}</td>
  </tr>
  <tr>
    <td>
      <input type="radio" [(ngModel)]="secondUnit" [name]="name" [value]="5" (ngModelChange)="onUnitChange(5, priceKg)" /> 
    </td>
    <td>kg</td>
    <!-- <td>{{dm.metrics.kg | number:'1.4-4'}}</td> -->
    <td>{{priceKg | number:'1.4-4'}}</td>
  </tr>
</table>